// extracted by mini-css-extract-plugin
var _1 = "ChapterPathNavigationButton__button--eInw8";
var _2 = "ChapterPathNavigationButton__locked--zAfGH";
var _3 = "ChapterPathNavigationButton__next--SZtF2 ChapterPathNavigationButton__button--eInw8";
var _4 = "ChapterPathNavigationButton__previous--VrZWJ ChapterPathNavigationButton__button--eInw8";
export { _1 as "button", _2 as "locked", _3 as "next", _4 as "previous" }
